var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    className: "nav-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 9.4L15 6.8L7 14.2C6.88 14.31 6.88 14.48 7 14.6C7.1 14.71 7.27 14.71 7.38 14.6L8.3 13.73V23H21.7V13.74L22.62 14.6C22.62 14.6 22.75 14.67 22.82 14.67C22.89 14.67 22.97 14.63 23.03 14.6C23.13 14.48 23.13 14.31 23.02 14.2L20.59 11.95L17.8 9.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.7e0449724c7d1198feb244c9db388568.svg";
export { ForwardRef as ReactComponent };